// Foundation CharacterSet.whitespacesAndNewlines on Darwin. JavaScript trim()
// intentionally differs for U+0085, so product parity must use this set.
export function trimSwiftWhitespaceAndNewlines(value: string): string {
	const scalars = Array.from(value);
	let start = 0;
	let end = scalars.length;
	while (start < end && isSwiftWhitespaceOrNewline(scalars[start])) {
		start += 1;
	}
	while (end > start && isSwiftWhitespaceOrNewline(scalars[end - 1])) {
		end -= 1;
	}
	return start === 0 && end === scalars.length
		? value
		: scalars.slice(start, end).join("");
}

function isSwiftWhitespaceOrNewline(character: string | undefined): boolean {
	const scalar = character?.codePointAt(0);
	return (
		scalar !== undefined &&
		((scalar >= 0x0009 && scalar <= 0x000d) ||
			scalar === 0x0020 ||
			scalar === 0x0085 ||
			scalar === 0x00a0 ||
			scalar === 0x1680 ||
			(scalar >= 0x2000 && scalar <= 0x200a) ||
			scalar === 0x2028 ||
			scalar === 0x2029 ||
			scalar === 0x202f ||
			scalar === 0x205f ||
			scalar === 0x3000)
	);
}
